"use strict";
import ApplicationForm from './ApplicationForm';
import {Tooltip} from 'bootstrap';
import debounce from "lodash.debounce";
import '../../../components/vendors/owlcarousel/init';
import {gh} from "../../general/general-helpers";

(function ($) {
    if ( document.body.classList.contains('page-school-landing') ) {

        /* Resize aside column in Hero section
        ** to be visually the same width as an aside column in the section below
        -------------------------------------------------------------------*/
        const heroPartnersAside = document.getElementById( 'hero-partners-aside' ),
              forWhomAside      = document.getElementById( 'suitable-for-whom' );
        function resize_hero_aside_col() {
            if ( ! gh.isDesktopDesign ) return;
            const heroPartnersProps = heroPartnersAside.getBoundingClientRect(),
                  newWidth = (heroPartnersProps.left - forWhomAside.getBoundingClientRect().left) + heroPartnersProps.width;
            heroPartnersAside.style.maxWidth = `${newWidth}px`;
        }

        gh.doOnEvent({
            load: null,
            resize: 150,
            orientationchange: null, // on window orientationchange (for older browsers)
        }, resize_hero_aside_col);


        // Menu scroll to anchor
        $('.offcanvas a').click(function (event) {
            $('#close-mobile-menu').trigger('click');
            if ($.attr(this, 'href') !== '#') {

                $('html, body').animate({
                    scrollTop: $($.attr(this, 'href')).offset().top + -30,
                }, 500);
            }
        });

        // Scroll to anchor from any page link
        $('main').on('click', 'a[href^="#"]', function (event) {
            if ($.attr(this, 'href') !== '#') {
                $('html, body').animate({
                    scrollTop: $($.attr(this, 'href')).offset().top + -30,
                }, 500);
            }
        });

        const peoplesSlider = document.querySelector('#people-slider');

        const schoolCarousel = () => {
            // People Slider
            $(peoplesSlider).owlCarousel({
                margin: 30,
                nav: true,
                dots: true,
                dotsClass: 'owl-dots --bw',
                navText: ['<img class="d-none d-md-inline-block flip-x" src="/wp-content/themes/yadro/assets/public/img/school-landing/icons/arrow-icon.svg" alt="left"><img class="d-md-none flip-x" src="/wp-content/themes/yadro/assets/public/img/school-landing/icons/arrow-icon--mobile.svg" alt="left">', '<img class="d-none d-md-inline-block" src="/wp-content/themes/yadro/assets/public/img/school-landing/icons/arrow-icon.svg" alt="right"><img class="d-md-none" src="/wp-content/themes/yadro/assets/public/img/school-landing/icons/arrow-icon--mobile.svg" alt="right">'],
                autoWidth: true,
                responsive: {
                    0: {
                        center: true,
                        loop: true,
                        items: 2,
                    },
                    768: {
                        center: true,
                        loop: true,
                        items: 3,
                    },
                    1200: {
                        items: 4,
                    },
                },
            });
        }

        const schoolCarouselApply = () => {
            if (window.innerWidth < 1320) {
                if (! peoplesSlider.classList.contains('owl-loaded')) {
                    schoolCarousel();
                }
            } else {
                if ( peoplesSlider.classList.contains('owl-loaded')) {
                    $(peoplesSlider).trigger('destroy.owl.carousel');
                }
            }
        }

        gh.doOnEvent({resize: 100}, schoolCarouselApply);

        schoolCarouselApply();

        if (typeof SchoolLandingData !== 'undefined') {
            let loaderSelector = SchoolLandingData && SchoolLandingData?.loader || '';
            let restUrl = SchoolLandingData && SchoolLandingData?.restUrl || '';
            let failMessage = SchoolLandingData && SchoolLandingData?.failMessage || 'Ошибка загрузки';

            // SchoolLanding form
            let formLoaders = document.querySelectorAll(loaderSelector);
            if (formLoaders && typeof SchoolLandingData !== 'undefined') {
                formLoaders.forEach((formLoader) => {
                    formLoader.querySelector('span').style.display = 'block';
                })

                fetch(restUrl, {
                    method: 'GET'
                })
                    .then(res => res.json())
                    .then(response => {
                        if (response?.data) {
                            // There is no point to create container if there will be no forms
                            let resultPopup = document.createElement('div');
                            resultPopup.classList.add('form__result', 'js-form-result');
                            document.body.append(resultPopup);

                            response.data.forEach((el) => {
                                formLoaders.forEach((formLoader, index) => {
                                    let form = createForm(el.html, index);
                                    let settings = SchoolLandingData || {};
                                    settings.templates = response?.responseTemplates || {};
                                    settings.contactEmail = response?.contactEmail || '';
                                    new ApplicationForm(form, settings, formLoader);
                                });
                            })
                        }
                    })
                    .catch(error => {
                        formLoaders.forEach((formLoader) => {
                            formLoader.text = failMessage;
                        })
                    });
            }

            function createForm(htmlString, index) {
                let formHtml = htmlString.replaceAll('[0]', '-' + index);

                var div = document.createElement('div');
                div.innerHTML = formHtml.trim();

                // Change this to div.childNodes to support multiple top-level nodes.
                return div.firstChild;
            }
        }


        /**
         * Opens Materials first tab (courses) after click
         * But page scrolls to the Materials section because the link has #mateials in href
         */
        // TODO Change this link for a class
        $('#prepare-opens-courses').on('click', function () {
            setTimeout(function () {
                document.getElementById('courses-tab').click();
            }, 100);
        });
        // End Form

        /* Contacts section nav slider
-------------------------------------------------------------------*/
        window.addEventListener( 'load', function() {
            let contactSlider = window.tns({
                container: '#contacts-tab',
                "autoWidth": true,
                // items: 6,
                // slideBy: "page",
                speed: 1000,
                responsive: {
                    100: {
                        slideBy: 1,
                    },
                    640: {
                        slideBy: 2,
                    },
                    960: {
                        slideBy: 3,
                    },
                    1440: {
                        slideBy: 3,
                    },
                    1600: {
                        slideBy: 4,
                    },
                },
                //
                autoplay: false,
                mouseDrag: true,
                loop: false,
                nav: false,
                // navPosition: "bottom",
                // edgePadding: 62,
                gutter: 50,
                arrowKeys: false,
                // // autoHeight: true,
                controls: true,
                controlsContainer: "#contacts-tab-nav",
            });
        });

        /* Big Map tooltips
        -------------------------------------------------------------------*/
        const tooltipTriggerList = document.querySelectorAll('.sm-overlay-city')
        if (tooltipTriggerList) {
            tooltipTriggerList.forEach(el => {
                const t = new Tooltip(el, {
                    // sanitize: false,
                    placement: 'top',
                    // trigger: 'manual',
                    html: true,
                    customClass: 'school-map__tooltip-show',
                // });
                } ).show();
            });
        } // IF | Map tooltips

        /* Lazy load for maps in the Contacts section
        -------------------------------------------------------------------*/
        const contactsSection = $('#contacts');
        contactsSection.on('shown.bs.tab', '.contacts-nav__link', function (e) {
            let mapScript = document.querySelector(`${e.target.dataset.bsTarget}`).querySelector('script');
            if (mapScript) {
                mapScript.setAttribute('src', mapScript.getAttribute('data-src'));
            }
        });

        /*global ymaps */
        /* Yandex map
        -------------------------------------------------------------------*/
        if (typeof ymaps !== 'undefined') {
            ymaps.ready( function() {
                if ( !yeSchoolMapData ) return;

                const myMap = new ymaps.Map( 'yandex-map', {
                    center: [54.735152, 45.958736],
                    zoom:   6,
                    controls: ['geolocationControl', 'zoomControl'],
                }, {
                    // Зададим опции для элементов управления.
                    // geolocationControlFloat: 'right',
                    geolocationControlPosition: {
                        bottom: '40px',
                        right: '15px'
                    },
                    zoomControlPosition: {
                        bottom: '90px',
                        right: '15px'
                    },
                    zoomControlSize: 'small',
                    suppressMapOpenBlock: true // Скрывает кнопки "Как добраться", "Доехать на такси" и т.д.
                    // searchControlProvider: 'yandex#search',
                } );
                myMap.behaviors.disable('scrollZoom');

                // Определяем метод getShape, который
                // будет возвращать размеры макета хинта.
                // Это необходимо для того, чтобы хинт автоматически
                // сдвигал позицию при выходе за пределы карты.
                const getShape = function() {
                    var el     = this.getElement(),
                        result = null;
                    if ( el ) {
                        var firstChild = el.firstChild;
                        result         = new ymaps.shape.Rectangle(
                            new ymaps.geometry.pixel.Rectangle( [
                                [0, 0],
                                [firstChild.offsetWidth, firstChild.offsetHeight],
                            ] ),
                        );
                    }
                    return result;
                }

                yeSchoolMapData.clusters.forEach( (item) => {

                    // Создание макета содержимого хинта.
                    // Макет создается через фабрику макетов с помощью текстового шаблона.
                    const HintLayout = ymaps.templateLayoutFactory.createClass( item.logos, {
                            getShape: getShape
                        },
                    );


                    const myPlacemark = new ymaps.Placemark( item.coordinates, {
                        // hintContent: 'Собственный значок метки',
                    }, {
                        // Опции.
                        hintLayout: HintLayout,
                        // hintCloseTimeout: 5000000,
                        hintCloseTimeout: 50,
                        hintOpenTimeout: 50,
                        hintHoldByMouse: false,
                        // Необходимо указать данный тип макета.
                        iconLayout: 'default#image',
                        // Своё изображение иконки метки.
                        iconImageHref: yeSchoolMapData.iconURI,
                        // Размеры метки.
                        iconImageSize: [30, 30],
                        // Смещение левого верхнего угла иконки относительно
                        // её "ножки" (точки привязки).
                        // iconImageOffset: [- 5, - 38],
                    } );

                    myMap.geoObjects.add( myPlacemark )

                } ); // FOREACH

            } );
        } // IF | ymaps


        /* Active accent underline links on load
        -------------------------------------------------------------------*/
        window.addEventListener( 'load', function() {
            document.querySelectorAll( '.accent-underline.--anim.--active' ).forEach( ( elem ) => {
                // make active and animate the link
                gh.activateAccentUnderlineLink( elem );
            } );
        } );

        $( document ).on( 'click', '.accent-underline.--anim', function( evt ) {
            // make active and animate the link, and deactivate sibling links
            gh.activateAccentUnderlineLink( this, $( this ).parents( '.accent-underline-parent' )[0] );
        } );

        $('.faq__item .faq__title').on('click', function (event) {
            send_faq_ywm_data($(this).data('number'));
        });

        let send_messages_ids=[];
        function send_faq_ywm_data(number) {
            if( send_messages_ids.includes(number) ) {
                return;
            }

            let messages = {
                1:"1. Какие требования для поступления?",
                2:'2. В чём преимущество очных занятий? И в каких городах я могу учиться в таком формате?',
                3:'3. В разделе про формат обучения указано, что мест в кластере может не хватить.',
                4:'4. Как подготовиться к Школе?',
                5:'5. Какое оборудование и ПО понадобится для участия в курсе и где его взять?',
                6:'6. Получу ли я какой-то документ об окончании Школы?',
                7:"7. Могу я учиться или работать во время обучения?",
                8:'8. Есть ли возможность учиться дистанционно',
                9:"9. Где мне взять платы для обучения? Выдают ли их на занятиях?",
            }

            const message = messages[number];

            if (!message) {
                console.warn("Не найдено сообщение с номером:", number);
                return;
            }

            const data = {
                "event_content":"Ответы на частые вопросы",
                "event_action":"accordion_click",
                "event_label": message,
            };

            window.YadroWebMetrics.track(data);
            send_messages_ids.push(number);
        }

    } // IF this page
})(jQuery);
